import { Box, Icon, Text } from '@ksyos/design-system';
import { Link as ReactRouterLink } from '@ksyos/router';
import { useMemo } from 'react';
import { calculateProgressForProgressBar } from '../../../../utils/questionnaireFunctions';
import { CardProgressBar } from '../../molecules/cardProgressBar/CardProgressBar';

interface IQuestionnaireCardProps {
    answers?: number;
    body: string;
    boxShadow?: string;
    className?: string;
    isSent?: boolean;
    questions?: number;
    title: string;
    to: string;
}
export function QuestionnaireCard(props: Readonly<IQuestionnaireCardProps>) {
    const { answers, body, boxShadow, isSent, questions, title } = props;
    const to = props.isSent ? '#' : props.to;

    const progress =
        !props.isSent && answers && questions ? calculateProgressForProgressBar(answers, questions) : undefined;

    const cardText = useMemo(() => {
        if (isSent) {
            return `Afgerond op ${props.body}`;
        } else if (answers && answers > 0) {
            return `Gestart | ${answers}/${questions}`;
        }

        return props.body;
    }, [answers, body, isSent, questions]);

    return (
        <ReactRouterLink
            aria-disabled={isSent}
            onClick={isSent ? (event) => event.preventDefault() : undefined}
            style={{ pointerEvents: isSent ? 'none' : 'auto', textDecoration: 'none' }}
            to={to}
        >
            <Box
                alignItems="center"
                backgroundColor="white"
                boxShadow={boxShadow || 'base'}
                display="flex"
                gap={4}
                px={6}
                py={4}
            >
                {isSent ? (
                    <img
                        alt={title}
                        src="/assets/images/somnology/questionnaires/questionnaire-afgerond.svg"
                        style={{ width: '54px' }}
                    />
                ) : (
                    <img
                        alt={title}
                        src="/assets/images/somnology/questionnaires/questionnaire-card-icon.svg"
                        style={{ width: '54px' }}
                    />
                )}

                <Box
                    flex={1}
                    gap={4}
                >
                    <Text
                        color="subtle"
                        fontWeight="medium"
                        marginBottom={1}
                    >
                        {title}
                    </Text>
                    <Text
                        className={props.className}
                        color="minimal"
                        marginBottom={2}
                        size="md"
                    >
                        {cardText}
                    </Text>
                    {progress && <CardProgressBar progress={progress}></CardProgressBar>}
                </Box>
                {!isSent && (
                    <Icon
                        color="minimal"
                        icon="caret-right"
                    />
                )}
            </Box>
        </ReactRouterLink>
    );
}
